import { PostCsvExcelAccountsApi } from "@/features/accounts/csv-excel/services/post-accounts-api";
import { PostCsvExcelAccountsRequestModel } from "@/features/accounts/csv-excel/services/post-accounts-model";

/// CsvExcel登録処理
export class PostCsvExcelAccountsService {
  private postCsvExcelAccountsApi = new PostCsvExcelAccountsApi();

  /**
   * CsvExcel登録API実行
   */
  public async postCsvExcelAccounts(param: PostCsvExcelAccountsRequestModel) {
    return await this.postCsvExcelAccountsApi.postCsvExcelAccounts(param);
  }
}
